import React, { useEffect, useRef, useState } from "react";
import * as pdfjs from "pdfjs-dist";
import workerSrc from "pdfjs-dist/build/pdf.worker?url";

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

const PdfThumbnail = ({ url, size = 48, onClick }) => {
  const canvasRef = useRef(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    if (!url || !canvasRef.current) return;

    const renderThumbnail = async () => {
      try {
        const loadingTask = pdfjs.getDocument({ url });
        const pdf = await loadingTask.promise;

        if (cancelled) return;

        const page = await pdf.getPage(1);
        const viewport = page.getViewport({ scale: 1 });

        const scale = size / viewport.width;
        const scaledViewport = page.getViewport({ scale });

        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        canvas.width = size;
        canvas.height = size;
        ctx.clearRect(0, 0, size, size);

        await page.render({
          canvasContext: ctx,
          viewport: scaledViewport,
        }).promise;

        pdf.cleanup();
        loadingTask.destroy();
      } catch (err) {
        console.error("PDF thumbnail error:", err);
        if (!cancelled) setError(true);
      }
    };

    renderThumbnail();

    return () => {
      cancelled = true;
    };
  }, [url, size]);

  if (error) {
    return (
      <div
        onClick={onClick}
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          background: "#F5F5F5",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "10px",
          color: "#999",
          cursor: "pointer",
          border: "1px solid #E0E0E0",
        }}
      >
        PDF
      </div>
    );
  }

  return (
    <canvas
      ref={canvasRef}
      onClick={onClick}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        cursor: "pointer",
        border: "1px solid #E0E0E0",
        background: "#fff",
      }}
    />
  );
};

export default PdfThumbnail;
